import { Component, OnInit ,Input} from '@angular/core';
import { PrincipalDasboardLibService } from '../principal-dasboard-lib.service';
import { ChartType } from 'angular-google-charts';

@Component({
  selector: 'lib-tableview',
  templateUrl: './tableview.component.html',
  styleUrls: ['./tableview.component.scss'],
})

export class TableviewComponent implements OnInit {
  @Input() set data(res: any) {
    this.loadTable(res);
    console.log("this.loadTable IS CALLED");
    
  }
  constructor(
    private pdService: PrincipalDasboardLibService
  ) {}
  resourseMetadata: any;
  tableRow: any;
  userMetadata: any;
  tableViewDiv: any;
  tblBody: any;
  myXmlData: any;
  myChartType = ChartType.Table;
  currentdataList:any;
  currentResoursedataList:any;
  tableViewData:any;
  alluserList:any;
  isUserWise = true;
 
  ngOnInit(): void {
  
  }
  loadTable(response: any){
    let parse = new DOMParser();
    this.myXmlData = parse.parseFromString(response, 'application/xml');
    if(this.myXmlData){
      //get current data list
      let genarateUserReqiuredData = this.pdService.genarateUserReqiuredData(this.myXmlData);
      this.currentdataList =genarateUserReqiuredData.userConsoleData;
     // get all user list 
      let fetchAlluserList = this.pdService.allUserChartData(genarateUserReqiuredData.userConsoleData,genarateUserReqiuredData.usersMetadata)
      this.alluserList = fetchAlluserList.fordurationTable;
      // resoureMetadata list
      this.currentResoursedataList = this.pdService.genarateResourseReqiuredData(this.myXmlData);
    }
    this.tableViewDiv = document.getElementById('tableViewDiv');
    this.tableRow = document.getElementById('tableRow');
    this.tblBody = document.getElementById('tblBody');
    this.tableViewDiv.style.display = 'none';
   
    this.pdService.chartType.subscribe((data) => {
      if (data) {
        this.updateChartType(data);
      }
    });
    this.pdService.isUserWise_data.subscribe((data) => {
      this.updateDataType(data);
    });
    this.pdService.isAllUsers.subscribe((data) => {
     if(data){
      this.showAllUser();
     }else{
      this.showCurrentDataUser();
     }
      
    });
  }
  showCurrentDataUser() {
    this.tableViewData = this.pdService.dataForTableView(this.currentdataList,this.currentResoursedataList);
    if(this.tableViewData){
      this.ueserWiseTableView(this.tableViewData);
    }
  }
  showAllUser() {
    this.tableViewData = this.pdService.dataForTableView(this.alluserList,this.currentResoursedataList);
    if(this.tableViewData){
      this.ueserWiseTableView(this.tableViewData);
    }
  }
  updateDataType(dataType: any) {
    this.isUserWise = dataType;
  }
  updateChartType(dataType: any) {
    this.myChartType = dataType;
      if (this.myChartType == ChartType.Timeline) {
      this.tableViewDiv.style.display = 'none';
    } else {
      this.tableViewDiv.style.display = 'block';
    }
  }
 
  ueserWiseTableView(resoureMetadata: any) {
    //  this.deleterow("tableRow");
    document.getElementById("tblBody").innerHTML = "";
    let labelArray = new Array();
    let cnt = 0;
    for (let i = 0; i < resoureMetadata.length; i++) {
      for (let j = 0; j < 12; j++) {
        let label = document.createElement('label');
        label.appendChild(document.createTextNode(resoureMetadata[i][j]));
        if (label.textContent === 'undefined') {
        label.textContent = '';
        }
        labelArray.push(label);
        // console.log("label",label);
      }
    }
    for (let j = 0; j <= resoureMetadata.length; j++) {
      let row = document.createElement('tr');
      
      let cell: any;
      for (let i = 0; i < 12; i++) {
        cell = document.createElement('td');
        
        if (cnt < labelArray.length) {
          cell.appendChild(labelArray[cnt]);
          row.appendChild(cell);
        }
        cnt++;
      }
      this.tblBody.appendChild(row);
      // this.tableRow.appendChild(this.tblBody);
    }
   
  }
}
